import { useQuery } from '@tanstack/react-query'
import { bookerService } from '../../services/bookers/bookerService'

export const useBookers = (params?: {
  page?: number
  limit?: number
  search?: string
}) => {
  return useQuery({
    queryKey: ['bookers', params],
    queryFn: () => bookerService.getBookers(params),
  })
}
